import { render, staticRenderFns } from "./TrackingDetailNotifyExtPanel.vue?vue&type=template&id=632b96ce&scoped=true&"
import script from "./TrackingDetailNotifyExtPanel.vue?vue&type=script&lang=js&"
export * from "./TrackingDetailNotifyExtPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632b96ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('632b96ce')) {
      api.createRecord('632b96ce', component.options)
    } else {
      api.reload('632b96ce', component.options)
    }
    module.hot.accept("./TrackingDetailNotifyExtPanel.vue?vue&type=template&id=632b96ce&scoped=true&", function () {
      api.rerender('632b96ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/business/TrackingDetailNotifyExtPanel.vue"
export default component.exports